class Parking {
  id?: string;

  name = '';

  capacity = 0;

  officeIds: string[] = [];

  // Occupancy-gauge override: "feels empty below" / "feels overcrowded above". Undefined means
  // inherit the office's threshold, or the organization default if the office has none either.
  thresholdMinPercentage?: number | null;

  thresholdMaxPercentage?: number | null;
}

export default Parking;
